export const SETUPDATELENS = 'SETUPDATELENS'

interface SetUpdateLens {
  type: typeof SETUPDATELENS
  payload: {
    n: boolean
  }
}

export const setUpdateLens = (n: boolean): SetUpdateLens => ({
  type: SETUPDATELENS,
  payload: {
    n,
  },
})

export type countActionTypes = SetUpdateLens
